// Two-step quote form on the homepage, submitted to Formie over ajax.
// Step 1: services + postcode, step 2: contact details. On success the visitor goes to the confirmation page set
// in Formie; step 3 is the fallback when the form has none.
const QUOTE_SUMMARY_KEY = 'laurijn.quoteSummary';

// Keeps what was requested for the confirmation page; it lives only as long as the browser tab
window.saveQuoteSummary = function (summary) {
    try {
        sessionStorage.setItem(QUOTE_SUMMARY_KEY, JSON.stringify(summary));
    } catch (error) {
        // Storage unavailable (private mode): the confirmation page simply leaves the summary out
    }
}

window.quoteForm = function (config) {
    return {
        step: 1,
        picked: [],
        postcode: '',
        error: false,
        submitting: false,
        serverErrors: [],
        submittedLabels: '',
        init() {
            // Coming back from the confirmation page via the back/forward cache
            window.addEventListener('pageshow', (event) => {
                if (event.persisted) {
                    this.submitting = false;
                }
            });

            // The situation helper preselects the services that belong to a situation
            window.addEventListener('quote-preselect', (event) => {
                this.picked = [...event.detail.services];
                this.step = 1;
                this.error = false;
            });
        },
        get pickedLabels() {
            return config.options
                .filter((option) => this.picked.includes(option.value))
                .map((option) => option.label)
                .join(', ');
        },
        next() {
            if (!this.picked.length) {
                this.error = true;
                return;
            }
            this.error = false;
            this.step = 2;
            this.$nextTick(() => this.$refs.firstName.focus());
        },
        back() {
            this.step = 1;
            this.$nextTick(() => this.$refs.stepOne.focus());
        },
        async submit(event) {
            const form = event.target;
            this.submitting = true;
            this.serverErrors = [];
            let redirecting = false;

            try {
                const result = await window.submitFormie(form, config);

                if (result.success && result.redirectUrl) {
                    this.storeSummary(form);
                    // Keep the button disabled while the confirmation page loads
                    redirecting = true;
                    window.location.assign(result.redirectUrl);
                    return;
                }

                if (result.success) {
                    this.submittedLabels = this.pickedLabels;
                    this.step = 3;
                    form.reset();
                    this.picked = [];
                    this.$nextTick(() => this.$refs.confirmation.focus());
                    return;
                }

                this.serverErrors = result.errors.length ? result.errors : [config.messages.generic];
            } catch (error) {
                this.serverErrors = [config.messages.generic];
            } finally {
                this.submitting = redirecting;
            }
        },
        storeSummary(form) {
            const data = new FormData(form);

            window.saveQuoteSummary({
                services: this.pickedLabels,
                address: [data.get('fields[addressLine1]'), data.get('fields[postalCode]')].filter(Boolean).join(', '),
                email: data.get('fields[email]') || '',
                phone: data.get('fields[phone][number]') || '',
            });
        },
        restart() {
            this.step = 1;
            this.error = false;
            this.serverErrors = [];
        },
    };
}

// Summary of the quote request on the confirmation page
window.quoteSummary = function () {
    return {
        summary: null,
        init() {
            try {
                this.summary = JSON.parse(sessionStorage.getItem(QUOTE_SUMMARY_KEY) || 'null');
            } catch (error) {
                this.summary = null;
            }
        },
        get contactLine() {
            return [this.summary?.email, this.summary?.phone].filter(Boolean).join(' · ');
        },
    };
}
